import { datadogRum } from '@datadog/browser-rum';
import type { RumInitConfiguration } from '@datadog/browser-rum';

import type { User } from '@evenfinancial/auth-client';

import type { ApplicationState } from '@/store';

import { DDEnv, getDDEnv, getDDRumBaseConfig } from './index';

export function init(config: ApplicationState['config']) {
  const baseConfig = getDDRumBaseConfig(config);

  // Validate required fields
  if (!baseConfig.clientToken || !baseConfig.env) {
    return;
  }

  const env = getDDEnv(config);
  const sessionReplaySampleRate = env === DDEnv.Prod ? 50 : 100;

  const rumConfig: RumInitConfiguration = {
    ...baseConfig,
    applicationId: 'd81e9e1c-fffb-4f4f-b965-ac2f9ce5b679',
    clientToken: baseConfig.clientToken,
    env: baseConfig.env,
    sessionReplaySampleRate,
  };

  datadogRum.init(rumConfig);
}

export function setUser(engineUser: User) {
  const {
    accountId,
    accountUuid,
    companyUuid,
    createdAt,
    createdById,
    emailAddress: email,
    updatedById,
    uuid,
  } = engineUser;

  const id = String(engineUser.id);

  datadogRum.setUser({
    accountId,
    accountUuid,
    companyUuid,
    createdAt,
    createdById,
    email,
    id,
    updatedById,
    uuid,
  });
}
